import React from 'react';
import {
    RichCell,
    Button, SplitLayout, SplitCol, Div, Accordion, Avatar, ButtonGroup, Link,
} from '@vkontakte/vkui';
import {
    AdaptivityContext, formatDateTime, getSalePointsTypes, userIsTradeChild,
} from "../assets/constants";

import {
    Icon16Clear,
    Icon20AddCircleFillGreen,
    Icon20DeleteOutline,
    Icon20EditCircleFillBlue,
    Icon20ViewOutline, Icon24CameraOutline
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import SalePointsApi from "../api/references/salePoints";
import BaseList from "../components/BaseList";
import SummaryListSalePoint from "../salePointsMonitoring/SummaryList";
import * as constants from "../assets/constants";
import Fancybox from "../assets/fancybox";
import {calcStandsShare, hasGroupTypeStats, STANDS_SHARE_MESSAGE} from "./standsShare";

function toAbsImageUrl(imagesUrl, src) {
    if (!src) {
        return ''
    }
    return imagesUrl + String(src).replace('https://lab', 'https://l').replace(imagesUrl, '')
}

function asImageList(raw) {
    if (Array.isArray(raw)) {
        return raw
    }
    if (raw && typeof raw === 'object') {
        return Object.keys(raw).map((key) => raw[key])
    }
    return []
}

class MapSalePointsList extends BaseList {

    constructor(props) {


        super(props);
        this.types = getSalePointsTypes()

    }

    openShareModal = (point, items) => {
        const {byGroupType} = calcStandsShare(items)
        const title = point.klient && point.klient.title
            ? `${point.klient.title} — ${point.title || ''}`
            : (point.title || 'Торговая точка')
        window.postMessage({
            type: STANDS_SHARE_MESSAGE,
            title: title.trim(),
            groupTypeStats: byGroupType,
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.item && this.props.item && prevProps.item.id != this.props.item.id) {
            this.getItems()
        } else if (formatDateTime(prevProps.date) != formatDateTime(this.props.date)) {
            this.getItems()
        }

    }

    getItems = (mainSearch = '', append, page) => {
        clearInterval(this.searchInterval);

        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }


        SalePointsApi.getListWithMonitoring(
            {
                date: formatDateTime(this.props.date),
                search: mainSearch,
                mall_id: this.props.item.isMall == 1 ? this.props.item.id : 0,
                sp_id: this.props.item.isMall == 0 ? this.props.item.id : 0,
                page,
                epp: AdaptivityContext.isMobile ? 10 : 20
            }
        ).then(response => {

            this.setState({loading: false})
            let old = this.state.items;
            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old})


            this.setState({cnt_items: response.data.iTotalRecords})
            this.setState({totalPages: response.data.iTotalPages})

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>

                </SplitCol>
                <SplitCol>
                    <Div>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>


                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }

    renderRow = (point, index) => {
        const isTradeChild = userIsTradeChild(this.props.current_user, point.user_id)
        const item = point.last_monitoring


        const foundCnt = {}
        const competitorCnt = {}

        const items_values = item && item.items ? item.items : []
        const itemsList = Array.isArray(items_values)
            ? items_values
            : Object.keys(items_values).map((id) => items_values[id])
        const {byGroupType} = calcStandsShare(itemsList)
        const showShareBtn = hasGroupTypeStats(byGroupType)


        Object.keys(items_values).map((id) => {
            if (items_values[id].is_competitor) {
                competitorCnt[id] = items_values[id]
            } else {
                foundCnt[id] = items_values[id]
            }
        })
        const images_url = this.props.base_url.replace("frontend/", '');
        const pointImages = asImageList(point.images).filter((img) => img && img.hasImage)
        const image = pointImages[0]
        const image2 = pointImages[1]
        const monitoringImages = asImageList(item && item.doc_data ? item.doc_data.images : null)
        const galleryName = 'gallerySp-' + point.id

        const base_url = constants.DEBUG ? constants.url_stage : constants.url_prod
        return <RichCell subhead={<Link href={`/sale_point_monitoring/?sp_id=${point.id}`} target="_blank">{point.full_address}</Link>}

                         multiline
                         afterCaption={
                             <div style={{display: 'flex'}}>
                                 <Fancybox key={'SpImagesFancyBox-' + point.id}>
                                     {image && <a data-fancybox={galleryName}
                                                  href={toAbsImageUrl(images_url, image.mainImage)}>
                                         {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                  size={AdaptivityContext.isMobile ? 70 : 100}
                                                  src={toAbsImageUrl(images_url, image.thumb)}/>}
                                     </a>}
                                     {image2 && <a data-fancybox={galleryName}
                                                   href={toAbsImageUrl(images_url, image2.mainImage)}>
                                         <img className="map-avatar" width="50" src={toAbsImageUrl(images_url, image2.thumb)} alt=""/>
                                     </a>}
                                     {pointImages.slice(2).map((extra, extraIndex) => (
                                         <a key={'sp-header-extra-' + point.id + '-' + extraIndex}
                                            data-fancybox={galleryName}
                                            href={toAbsImageUrl(images_url, extra.mainImage)}
                                            style={{display: 'none'}}/>
                                     ))}
                                 </Fancybox>
                             </div>
                         }
                         caption={
                             <span>Автор: <b>{point.author_name}</b> Изменено: {point.modified}</span>}
                         a_fterCaption={<div style={{
                             display: "flex",
                             flexDirection: "column"
                         }}>
                             <Button mode="secondary"
                                     onClick={() => window.postMessage({
                                         type: 'setCurrentSalePoint',
                                         value: point
                                     })}
                                     size="s">{isTradeChild ?
                                 <Icon20EditCircleFillBlue/> :
                                 <Icon20ViewOutline/>}</Button>
                             {isTradeChild && <Button mode="secondary"
                                                      onClick={() => this.setState({
                                                          delete_id: point.id,
                                                          showDeleteSalePointAlert: true
                                                      })}
                                                      size="s"><Icon20DeleteOutline/></Button>}
                         </div>}

                         bottom={item && <div>
                             {item.doc_data && item.doc_data.id ? (
                                 <Link href={`/sale_point_monitoring/${item.doc_data.id}/1`} target="_blank" rel="noopener noreferrer">
                                     <smal>Последний мониторинг:</smal> <b>{item.doc_data.nomer}</b> от {item.doc_data.date}
                                 </Link>
                             ) : (
                                 <span><smal>Последний мониторинг:</smal> <b>{item.doc_data.nomer}</b> от {item.doc_data.date}</span>
                             )}
                             {showShareBtn && <Div style={{paddingLeft: 0, paddingRight: 0}}>
                                 <Button mode="outline"
                                         appearance="negative"
                                         size="m"
                                         stretched
                                         style={{
                                             borderWidth: 2,
                                             fontWeight: 700,
                                             textTransform: 'uppercase',
                                         }}
                                         onClick={() => this.openShareModal(point, itemsList)}>
                                     Доля видов стендов
                                 </Button>
                             </Div>}
                             <SplitLayout>
                                 <SplitCol>
                                     <Accordion className="summary-element">
                                         <Accordion.Summary>Наши
                                             стенды: {Object.keys(foundCnt).length}</Accordion.Summary>
                                         <SummaryListSalePoint readonly list={foundCnt} current_document={item}/>
                                     </Accordion>
                                 </SplitCol>
                             </SplitLayout>

                             <SplitLayout>
                                 <SplitCol>
                                     <Accordion className="summary-element">
                                         <Accordion.Summary>Стенды
                                             конкурентов: {Object.keys(competitorCnt).length}</Accordion.Summary>
                                         <SummaryListSalePoint readonly list={competitorCnt} current_document={item}/>
                                     </Accordion>
                                 </SplitCol>
                             </SplitLayout>
                             {monitoringImages.length > 0 && <SplitLayout>
                                 <SplitCol>
                                     <Div className="incoming-photos-gallery" style={{marginBottom: '5px'}}>
                                         <Fancybox key={'MonitoringFancyBox-' + galleryName}>
                                             {monitoringImages.map((image_item, index) => {
                                                 if (!image_item) {
                                                     return null
                                                 }

                                                 return (
                                                     <div className="main-catalog_product-wrapper_avatar"
                                                          key={'sp-mon-img-' + galleryName + '-' + index}
                                                          style={{width: AdaptivityContext.isMobile ? '78px' : '108px'}}>
                                                         {image_item.hasImage ?
                                                             <a data-fancybox={galleryName}
                                                                href={toAbsImageUrl(images_url, image_item.mainImage)}>
                                                                 {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                                          size={AdaptivityContext.isMobile ? 70 : 100}
                                                                          src={toAbsImageUrl(images_url, image_item.thumb)}/>}
                                                             </a>
                                                             :
                                                             <Avatar mode="image" style={{borderRadius: '5%'}}

                                                                     size={AdaptivityContext.isMobile ? 70 : 100}
                                                                     src={images_url + constants.EMPTY_IMG}/>
                                                         }
                                                     </div>
                                                 )
                                             })}
                                         </Fancybox>
                                     </Div>
                                 </SplitCol>
                             </SplitLayout>}
                         </div>}
        >

            <b>{point.klient.title}</b>
            <p>{this.types[point.type_]} {point.title}{point.trading_floor ? ', Зал: ' + point.trading_floor : ''}</p>
        </RichCell>
    }

}

export default MapSalePointsList
